module.exports = __webpack_public_path__ + "media/images/red-14f22673572cdb23b56184debe1ea250.png";